// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let AgentPropertyMlsStatus = require("./AgentPropertyMlsStatus.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalPropertyStatus_rentalPropertyV5_graphql = require("../../../__generated__/RentalPropertyStatus_rentalPropertyV5_graphql.bs.js");

let convertFragment = RentalPropertyStatus_rentalPropertyV5_graphql.Internal.convertFragment;

function RentalPropertyStatus$WithoutErrorBoundary(props) {
  let size = props.size;
  let property = RescriptRelay_Fragment.useFragment(RentalPropertyStatus_rentalPropertyV5_graphql.node, convertFragment, props.property);
  let match = property.status;
  let tmp;
  switch (match.__typename) {
    case "ExpiredProperty" :
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {}),
          JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
            property: property.fragmentRefs,
            size: size
          })
        ]
      });
      break;
    case "RentedProperty" :
      tmp = JsxRuntime.jsx(Labels.RentedLabel.make, {});
      break;
    case "WithdrawnProperty" :
      tmp = JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
      break;
    case "ActiveProperty" :
    case "__unselected" :
      tmp = JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
        property: property.fragmentRefs,
        size: size
      });
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex gap-4"
  });
}

function RentalPropertyStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property status",
    children: JsxRuntime.jsx(RentalPropertyStatus$WithoutErrorBoundary, {
      property: props.property,
      size: props.size
    })
  });
}

let make = RentalPropertyStatus;

exports.make = make;
/* Labels Not a pure module */
